export default __webpack_public_path__ + "static/media/mixamato-logo.6300380e.svg";